const getCssTextFromCssVariablesMap = (cssVariablesMap) => {
  return Object.entries(cssVariablesMap).reduce((cssText, propertyRule) => {
    const [prop, value] = propertyRule;
    return `${cssText}${prop}:${value};`;
  }, '');
};

export default getCssTextFromCssVariablesMap;
